import { TeamRole } from '@foxtrotplatform/platform-micro-site-core';
import React from 'react';

import { FriendlyUserRole } from '../../common/enums';

interface RoleTypeProps {
  role: TeamRole;
}

export const RoleTypeComponent: React.FunctionComponent<RoleTypeProps> = ({
  role,
}) => {
  let textColor;
  switch (role) {
    case TeamRole.DEVELOPER:
      textColor = 'text-brand-blue';
      break;
    case TeamRole.DEVELOPER_TEAM_ADMIN:
      textColor = 'text-purple-500';
      break;
  }

  return (
    <span
      className={`${textColor} rounded-full py-0.5 px-2 bg-indigo-100 text-xs font-medium uppercase`}
    >
      {FriendlyUserRole[role]}
    </span>
  );
};
